/**
 * Shop The Look Button Inserter
 * 监听 ProductWiz 生成的 DOM，将 Shop The Look 按钮插入到指定的 slide 中
 */

class ShopTheLookInserter {
  constructor() {
    this.mediaWrapper = null;
    this.shopLookButton = null;
    this.targetSlideIndex = 1; // 默认第一张
    this.inserted = false;
    this.observer = null;

    this.init();
  }

  init() {
    // 等待 DOM 加载完成
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.start());
    } else {
      this.start();
    }
  }

  start() {
    // 查找媒体容器 - 找到 display 不为 none 的 product__media-wrapper
    const visibleMediaWrapper = Array.from(document.querySelectorAll('.product__media-wrapper')).find(
      wrapper => getComputedStyle(wrapper).display !== 'none'
    );

    if (!visibleMediaWrapper) {
      console.warn('[ShopTheLook] No visible product__media-wrapper found');
      return;
    }

    this.mediaWrapper = visibleMediaWrapper.querySelector('#pwzrswiper-container-wrapper #pwzrswiper-wrapper');
    if (!this.mediaWrapper) {
      console.warn('[ShopTheLook] Media wrapper not found in visible product__media-wrapper');
      return;
    }

    // 查找按钮（可能在原始位置）
    this.shopLookButton = document.querySelector('.shop-the-look-trigger');
    if (!this.shopLookButton) {
      console.warn('[ShopTheLook] Button not found');
      return;
    }

    // 获取目标 slide 索引
    const indexAttr = this.shopLookButton.getAttribute('data-slide-index');
    if (indexAttr) {
      this.targetSlideIndex = parseInt(indexAttr, 10);
    }

    // 检查是否已经有 ProductWiz 的 slides
    this.tryInsertButton();

    // 如果没有插入成功，启动 MutationObserver
    if (!this.inserted) {
      this.observeDOMChanges();
    }
  }

  /**
   * 尝试插入按钮到目标 slide
   */
  tryInsertButton() {
    const slides = this.mediaWrapper.querySelectorAll('.pwzrswiper-slide');

    if (slides.length === 0) {
      return false;
    }

    // 确定目标索引（从1开始，数组从0开始）
    let targetIndex = this.targetSlideIndex - 1;

    // 边界检查
    if (targetIndex < 0) {
      targetIndex = 0;
    } else if (targetIndex >= slides.length) {
      targetIndex = slides.length - 1;
    }

    const targetSlide = slides[targetIndex];

    if (!targetSlide) {
      return false;
    }

    // 确保 slide 有相对定位
    if (getComputedStyle(targetSlide).position === 'static') {
      targetSlide.style.position = 'relative';
    }

    // 克隆按钮（保留事件监听器）
    const buttonClone = this.shopLookButton.cloneNode(true);

    // 移除原始按钮的隐藏状态
    buttonClone.classList.remove('hidden');
    buttonClone.style.display = '';

    // 添加特定类标识这是插入到 slide 的按钮
    buttonClone.classList.add('shop-the-look-trigger--in-slide');

    // 重新绑定事件（因为 cloneNode 不复制事件监听器）
    const drawerOpener = buttonClone.querySelector('drawer-opener');
    if (drawerOpener) {
      const button = drawerOpener.querySelector('button');
      if (button) {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          const drawerId = drawerOpener.getAttribute('data-drawer');
          const drawer = document.querySelector(drawerId);
          if (drawer) {
            drawer.open(button);
          }
        });
      }
    }

    // 插入到目标 slide
    targetSlide.appendChild(buttonClone);

    // 隐藏原始按钮
    this.shopLookButton.style.display = 'none';

    this.inserted = true;
    console.log(`[ShopTheLook] Button inserted into slide ${this.targetSlideIndex}`);

    // 停止观察
    if (this.observer) {
      this.observer.disconnect();
    }

    return true;
  }

  /**
   * 使用 MutationObserver 监听 DOM 变化
   */
  observeDOMChanges() {
    this.observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        // 检查是否有新增的节点
        if (mutation.addedNodes.length > 0) {
          // 检查是否出现了 pwzrswiper-slide
          const hasSlides = Array.from(mutation.addedNodes).some(node => {
            return node.nodeType === 1 && (
              node.classList?.contains('pwzrswiper-slide') ||
              node.querySelector?.('.pwzrswiper-slide')
            );
          });

          if (hasSlides) {
            // 尝试插入按钮
            if (this.tryInsertButton()) {
              break;
            }
          }
        }
      }
    });

    // 开始观察
    this.observer.observe(this.mediaWrapper, {
      childList: true,
      subtree: true
    });

    console.log('[ShopTheLook] MutationObserver started');

    // 设置超时，避免无限等待
    setTimeout(() => {
      if (!this.inserted) {
        console.warn('[ShopTheLook] Timeout: ProductWiz slides not detected, showing button in original position');
        this.shopLookButton.style.display = '';
        if (this.observer) {
          this.observer.disconnect();
        }
      }
    }, 5000); // 5秒超时
  }
}

// 初始化
if (typeof window !== 'undefined') {
  window.shopTheLookInserter = new ShopTheLookInserter();
}
